import React, { FC, useMemo } from 'react';

import { useUnitName } from '$hooks';
import { UnitNameProps } from './UnitName.interface';
import { noteSelector } from '$store/notes';
import { useSelector } from 'react-redux';
import { RootState } from '$store/rootReducer';

const UnitNameComponent: FC<UnitNameProps> = ({
  unit,
  inclineCase,
  namePart,
  withoutNote = false,
  isNoteExist = false,
}) => {
  const name = useUnitName(unit, inclineCase, namePart);
  const userNote = useSelector((state: RootState) => noteSelector(state, unit?.id || -1));

  const getUserName = (isNote: boolean) => (isNote ? userNote!.name : name);

  const text = useMemo(() => {
    if (unit?.verified !== 2) {
      const isUserNoteExist = !!userNote && userNote.name.length > 0;

      if (isNoteExist) {
        if (isUserNoteExist) {
          return `(${name})`;
        } else {
          return '';
        }
      }

      if (userNote && !withoutNote) {
        return getUserName(isUserNoteExist);
      }
    }

    return name;
  }, [name, userNote]);

  return <>{text}</>;
};

export const UnitName = React.memo(UnitNameComponent);
